const NAMESPACE = 'core.threads.transfer';
/**
 * Зарезервированное свойство, которое должно содержать уникальное имя
 */
const kStructuredCloneMarker = Symbol('kStructuredCloneMarker');
const kSendMarker = Symbol('kSendMarker');
const kCloneMethod = Symbol('kCloneMethod');
const kMoveMarker = Symbol('kMoveMarker');
const kMoveState = Symbol('kMoveState');
const kMoveMethod = Symbol('kMoveMethod');
function isStructuredClone(val) {
    return (((typeof val === 'object' && val !== null) || typeof val === 'function') &&
        !!val[kStructuredCloneMarker]);
}
/**
 * Хелперы для типа {@linkcode Clone}
 */
const Clone = {
    is(val) {
        return Array.isArray(val) && (val.length === 2 || val.length === 3) && typeof val[0] === 'string';
    },
    isStruct(val) {
        return Clone.is(val) && val.length === 2;
    },
    isTransferable(val) {
        return Clone.is(val) && val.length === 3;
    },
    toStruct(val) {
        return [val[0], val[1]];
    },
};
const Move = {
    is(val) {
        return isStructuredClone(val) && !!val[kMoveMarker];
    },
};
const Send = {
    /**
     * Проверяет, является {@param T} типом {@linkcode ISend}
     *
     * @export
     * @template T - любой тип
     * @param {T} val
     */
    is(val) {
        return isStructuredClone(val) && !!val[kSendMarker];
    },
    isCloneable(val) {
        return Send.is(val) && !!val[kCloneMethod];
    },
};

export { Clone, Move, NAMESPACE, Send, isStructuredClone, kCloneMethod, kMoveMarker, kMoveMethod, kMoveState, kSendMarker, kStructuredCloneMarker };
//# sourceMappingURL=transfer.js.map
